import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";
import { getResponsiveStylingClassNames } from "@faire/retailer/components/SDUI/__internal__/Styling/responsiveValues";
import { getResponsiveSpacingPixels } from "@faire/retailer/components/SDUI/__internal__/Styling/spacing";
import * as styles from "@faire/retailer/components/SDUI/ComponentRenderers/Spacer/styles/SDUISpacerRendererStyles.css";
export var SDUISpacerRenderer = function(param) {
    var component = param.component;
    var spacerComponent = component.spacer_component;
    if (!spacerComponent) {
        return null;
    }
    var vertical_spacing = spacerComponent.vertical_spacing, responsive_vertical_spacing = spacerComponent.responsive_vertical_spacing, style = spacerComponent.style;
    var variant = style === null || style === void 0 ? void 0 : style.variant;
    var responsiveValues = getResponsiveSpacingPixels(vertical_spacing, responsive_vertical_spacing);
    if (!variant || !responsiveValues.mobileAndAbove) {
        return null;
    }
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        "data-test-id": "sdui-spacer",
        className: classNames(styles.spacerStyle, styles.mobileAndAboveSpacing, getResponsiveStylingClassNames(responsiveValues, ResponsiveVerticalSpacingClassNames)),
        style: assignInlineVars((_obj = {}, _define_property(_obj, styles.mobileAndAboveHeight, "".concat(responsiveValues.mobileAndAbove)), _define_property(_obj, styles.tabletAndAboveHeight, "".concat(responsiveValues.tabletAndAbove)), _define_property(_obj, styles.desktopAndAboveHeight, "".concat(responsiveValues.desktopAndAbove)), _obj)),
        children: variant === "HORIZONTAL_LINE" ? /*#__PURE__*/ _jsx(HorizontalLine, {
            color: (style === null || style === void 0 ? void 0 : style.color) !== undefined ? getSlateColorToken(style.color) : undefined
        }) : null
    });
};
var ResponsiveVerticalSpacingClassNames = {
    tabletAndAbove: styles.tabletAndAboveSpacing,
    desktopAndAbove: styles.desktopAndAboveSpacing
};
